export default {
    'buttonLabelExport': 'Export',
};
